export default __webpack_public_path__ + "static/char-39-27f4d65fe01c5956fe02d8a40febba5e.webp";